import builder from '../builder';
import Pin from '../../streamline-icons/light/pin.svg';
export default builder('IconPinLight', Pin);
//# sourceMappingURL=Pin.js.map